import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { ApplicationState, AppState } from '../../../store';
import { withSnackbar, ProviderContext } from 'notistack';
import { ITranslatorService } from '../../../services/Interfaces/ITranslatorService';
import { ApplicationContext, AppContext } from '../../../context/Contexts';
import {
  Tooltip,
  Box,
  Button,
  IconButton,
  Dialog,
  DialogTitle,
  Grid,
  Typography,
  DialogContent
} from '@material-ui/core';
import { ScaleLoader } from 'react-spinners';
import AddCircleTwoToneIcon from '@material-ui/icons/AddCircleTwoTone';
import { RouteComponentProps } from 'react-router';
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator';
import Autocomplete from '@material-ui/lab/Autocomplete';
import MUIDataTable, {
  SelectableRows,
  MUIDataTableMeta,
  MUIDataTableColumnOptions
} from 'mui-datatables';
import { MUITranslations } from '../../../helpers/MUITableTranslations';
import CloseIcon from '@material-ui/icons/Close';
import DeleteOutlineTwoToneIcon from '@material-ui/icons/DeleteOutlineTwoTone';
import { MavoInvoiceRangeCodes, RefConstants, RoleClaimsEnum } from '../../../helpers/Constants';
import { IReferential } from '../../../interfaces/IReferential';
import { IReferentialService } from '../../../services/Interfaces/IReferentialService';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import NumberFormat from 'react-number-format';
import { IVehicleService } from '../../../services/Interfaces/IVehicleService';
import { InvoiceRange } from '../../../interfaces/Vehicle';
import * as R from 'ramda';

interface IInvoiceRangeListState {
  newInvoiceRange: InvoiceRange;
  invoiceRangeTypes: IReferential[];
  invoiceRangeStatuses: IReferential[];
  invoiceRanges: InvoiceRange[];
  isLoading: boolean;
  isDialogOpen: boolean;
  newInvoiceRangeId: number | null;
}

type IInvoiceRangeListProps = { appState: AppState } & ProviderContext &
  RouteComponentProps<{ id: string; workflowId: string }>;

class InvoiceRangeList extends React.PureComponent<
  IInvoiceRangeListProps,
  IInvoiceRangeListState
> {
  private translatorService!: ITranslatorService;
  private vehicleService!: IVehicleService;
  private appReferentialService!: IReferentialService;


  static contextType = ApplicationContext;
  private newInvoiceRange = {
    id: 0,
    invoiceRangeTypeId: null,
    invoiceRangeType:  null,
    firstSeries: null,
    startingNumber: null,
    currentNumber: null,
    endingNumber: null,
    lastSeries: null,
    invoiceRangeStatusId: null,
    invoiceRangeStatus: null
  } as unknown as InvoiceRange;

  state = {
    invoiceRanges: [],
    isLoading: false,
    selectedFilter: 0,
    isDialogOpen: false,
    newInvoiceRange: this.newInvoiceRange,
    invoiceRangeTypes: [],
    invoiceRangeStatuses: [],
    newInvoiceRangeId: null
  } as IInvoiceRangeListState;

  public componentDidMount() {
    this.setState(
      {
        isLoading: true
      },
      async () => {
        await this.loadInvoiceRanges();
      }
    );
  }

  loadInvoiceRanges = async () => {
    let invoiceRanges = await this.vehicleService.GetInvoiceRanges();
    const { invoiceRangeTypeRef, invoiceRangeStatusRef } = RefConstants;

    const [invoiceRangeTypes, invoiceRangeStatuses] = await Promise.all([
      this.appReferentialService.Get(invoiceRangeTypeRef!.baseUrl),
      this.appReferentialService.Get(invoiceRangeStatusRef!.baseUrl)
    ]);

    if (this.hasRight(RoleClaimsEnum.MavoAdministrator)){
      invoiceRanges = invoiceRanges.filter((item) => MavoInvoiceRangeCodes.includes(item.invoiceRangeType!.code!));
    }

    this.setState({
      invoiceRanges: invoiceRanges,
      isLoading: false,
      invoiceRangeTypes: invoiceRangeTypes.filter((item) => MavoInvoiceRangeCodes.includes(item.code!)),
      invoiceRangeStatuses: invoiceRangeStatuses,
      newInvoiceRange: { ...this.newInvoiceRange }
    });
  };

  public hasRight = (right: string): boolean => {
    return this.props.appState!.user!.profile.role.includes(right);
  };

  private handleInvoiceRangeTypeChange = (newValue: IReferential | null) => {
    this.setState({
      newInvoiceRange: {
        ...this.state.newInvoiceRange,
        invoiceRangeType: newValue,
        invoiceRangeTypeId: newValue !== null ? newValue!.id : 0
      }
    });
  };

  
  private handleInvoiceRangeStatusChange = (newValue: IReferential | null) => {
    this.setState({
      newInvoiceRange: {
        ...this.state.newInvoiceRange,
        invoiceRangeStatus: newValue,
        invoiceRangeStatusId: newValue !== null ? newValue!.id : 0
      }
    });
  };

  public saveInvoiceRange = async () => {
    if (!R.isNil(this.state.newInvoiceRange.startingNumber) && !R.isNil(this.state.newInvoiceRange.endingNumber)) {
      if (this.state.newInvoiceRange.endingNumber < this.state.newInvoiceRange.startingNumber) {
        this.props.enqueueSnackbar(this.translatorService.Tranlate('INVOICE_RANGE_ENDING_NUMBER_ERROR', 'Numarul de sfarsit trebuie sa fie mai mare decat numarul de inceput!'), {
          variant: 'error'
        });
        return;
      }
    }

    if (this.state.newInvoiceRangeId === null) {
      try {
        await this.vehicleService.AddInvoiceRange(this.state.newInvoiceRange);

        await this.loadInvoiceRanges();

        this.closeDialog();

        this.props.enqueueSnackbar(this.translatorService.Tranlate('SUCCES_MSG', 'OK'), {
          variant: 'success'
        });
      } catch (error) {
        this.props.enqueueSnackbar(this.translatorService.Tranlate('ERROR_MSG', 'Eroare'), {
          variant: 'error'
        });
      }
    } else {
      try {

        await this.vehicleService.UpdateInvoiceRange(this.state.newInvoiceRange);

        await this.loadInvoiceRanges();

        this.closeDialog();

        this.props.enqueueSnackbar(this.translatorService.Tranlate('SUCCES_MSG', 'OK'), {
          variant: 'success'
        });
      } catch (error) {
        this.props.enqueueSnackbar(this.translatorService.Tranlate('ERROR_MSG', 'Eroare'), {
          variant: 'error'
        });
      }
    }
  };
  
  
  NumberFormatCustom = (props: any) => {
    const { inputRef, onChange, ...other } = props;

    return (
      <NumberFormat
        {...other}
        getInputRef={inputRef}
        onValueChange={(values: any) => {
          onChange({
            target: {
              value: values.value
            },
            currentTarget: {
              value: values.value
            }
          });
        }}
        allowNegative={false}
        thousandSeparator={false}
        decimalScale={0}
      />
    );
  };
  
  onChange =
  (fieldName: string, isNumber: boolean) => (e: any, newValue?: IReferential | null) => {
    isNumber
      ? this.setState({
        newInvoiceRange: {
            ...this.state.newInvoiceRange,
            [fieldName]: parseFloat(newValue || e.target.value)
          }
        })
      : this.setState({
        newInvoiceRange: {
            ...this.state.newInvoiceRange,
            [fieldName]: newValue || e.target.value
          }
        });
  };

  public renderAddForm() {
    return (
      <ValidatorForm onSubmit={this.saveInvoiceRange} instantValidate={true}>
        <Box mb={2}>
          <Autocomplete
            id="invoiceRangeType"
            fullWidth
            options={this.state.invoiceRangeTypes}
            value={this.state.newInvoiceRange.invoiceRangeType}
            onChange={(e: any, newValue: IReferential | null) =>
              this.handleInvoiceRangeTypeChange(newValue)
            }
            getOptionLabel={(option: IReferential) => option.displayName || ''}
            renderInput={(params) => (
              <TextValidator
                {...params}
                name="invoiceRangeType"
                value={this.state.newInvoiceRange.invoiceRangeType}
                label={this.translatorService.Tranlate(
                  'INVOICE_RANGE_TYPE',
                  'Tip'
                )}
                fullWidth
                validators={['required']}
                errorMessages={[
                  this.translatorService.Tranlate(
                    'VALIDATORS_REQUIRED',
                    'Campul este obligatoriu'
                  )
                ]}
              />
            )}
          />
        </Box>

        <Box mb={2}>
          <TextValidator
            fullWidth
            id="firstSeries"
            name="firstSeries"
            placeholder={this.translatorService.Tranlate('INVOICE_RANGE_FIRST_SERIES', 'Serie 1')}
            value={this.state.newInvoiceRange.firstSeries}
            onChange={(e: any) =>
              this.onChange('firstSeries', false)(e)
            }
            validators={['required']}
            errorMessages={[
              this.translatorService.Tranlate('VALIDATORS_REQUIRED', 'Campul este obligatoriu')
            ]}
            label={this.translatorService.Tranlate('INVOICE_RANGE_FIRST_SERIES', 'Serie 1')}
          />
        </Box>

        <Box mb={2}>
          <TextValidator
            fullWidth
            id="startingNumber"
            name="startingNumber"
            placeholder={this.translatorService.Tranlate('INVOICE_RANGE_STARTING_NUMBER', 'Numar inceput')}
            value={this.state.newInvoiceRange.startingNumber || '' }
            onChange={(e: any) => this.onChange('startingNumber', true)(e)}
            validators={['required']}
            errorMessages={[
              this.translatorService.Tranlate('VALIDATORS_REQUIRED', 'Campul este obligatoriu')
            ]}
            label={this.translatorService.Tranlate('INVOICE_RANGE_STARTING_NUMBER', 'Numar inceput')}
            InputProps={{
              inputComponent: this.NumberFormatCustom
            }}
          />
        </Box>
        <Box mb={2}>
          <TextValidator
            fullWidth
            id="endingNumber"
            name="endingNumber"
            placeholder={this.translatorService.Tranlate('INVOICE_RANGE_ENDING_NUMBER', 'Numar sfarsit')}
            value={this.state.newInvoiceRange.endingNumber || ''}
            onChange={(e: any) => this.onChange('endingNumber', true)(e)}
            validators={['required']}
            errorMessages={[
              this.translatorService.Tranlate('VALIDATORS_REQUIRED', 'Campul este obligatoriu')
            ]}
            label={this.translatorService.Tranlate('INVOICE_RANGE_ENDING_NUMBER', 'Numar sfarsit')}
            InputProps={{
              inputComponent: this.NumberFormatCustom
            }}
            error={!R.isNil(this.state.newInvoiceRange.startingNumber) && !R.isNil(this.state.newInvoiceRange.endingNumber) ?
              (this.state.newInvoiceRange.endingNumber < this.state.newInvoiceRange.startingNumber ? true : false) : false}
            helperText={
              !R.isNil(this.state.newInvoiceRange.startingNumber) && !R.isNil(this.state.newInvoiceRange.endingNumber) ?
              (this.state.newInvoiceRange.endingNumber < this.state.newInvoiceRange.startingNumber ?
                this.translatorService.Tranlate(
                'INVOICE_RANGE_ENDING_NUMBER_ERROR',
                'Numarul de sfarsit trebuie sa fie mai mare decat numarul de inceput!'
              ) : '') : ''
              }
          />
        </Box>

        <Box mb={2}>
          <TextValidator
            fullWidth
            id="lastSeries"
            name="lastSeries"
            placeholder={this.translatorService.Tranlate('INVOICE_RANGE_LAST_SERIES', 'Serie 2')}
            value={this.state.newInvoiceRange.lastSeries}
            onChange={(e: any) => this.onChange('lastSeries', false)(e)}
            validators={['required']}
            errorMessages={[
              this.translatorService.Tranlate('VALIDATORS_REQUIRED', 'Campul este obligatoriu')
            ]}
            label={this.translatorService.Tranlate('INVOICE_RANGE_LAST_SERIES', 'Serie 2')}
          />
        </Box>

        <Box mb={2}>
          <Autocomplete
            id="invoicRangeStatus"
            fullWidth
            options={this.state.invoiceRangeStatuses}
            value={this.state.newInvoiceRange.invoiceRangeStatus}
            onChange={(e: any, newValue: IReferential | null) =>
              this.handleInvoiceRangeStatusChange(newValue)
            }
            getOptionLabel={(option: IReferential) => option.displayName || ''}
            renderInput={(params) => (
              <TextValidator
                {...params}
                name="invoicRangeStatus"
                value={this.state.newInvoiceRange.invoiceRangeStatus}
                label={this.translatorService.Tranlate(
                  'INVOICE_RANGE_STATUS',
                  'Status'
                )}
                fullWidth
                validators={['required']}
                errorMessages={[
                  this.translatorService.Tranlate(
                    'VALIDATORS_REQUIRED',
                    'Campul este obligatoriu'
                  )
                ]}
              />
            )}
          />
        </Box>

        <div className="text-right">
          <Button
            className="m-2"
            variant="outlined"
            color="default"
            onClick={this.closeDialog}
          >
            {this.translatorService.Tranlate('EDIT_ORGANIZATION_CANCEL_BTN', 'Anuleaza')}
          </Button>
          <Button className="m-2" variant="contained" color="secondary" type="submit">
            {this.translatorService.Tranlate('EDIT_ORGANIZATION_SAVE_BTN', 'Salveaza')}
          </Button>
        </div>
    </ValidatorForm>
    );
  }

  getColumns = () => {
    const columns = [
      {
        name: 'id',
        label: this.translatorService.Tranlate('INVOICE_RANGE_NR', 'NR'),
      },
      {
        name: 'invoiceRangeType',
        label: this.translatorService.Tranlate(
          'INVOICE_RANGE_TYPE',
          'Tip'
        ),
        options: {
          sort: true,
          customSort: (a: IReferential, b: IReferential) => {
            return a.name!.localeCompare(b.name!);
          },
          customBodyRender: (value: IReferential) => {
            return value.name;
          }
        } as MUIDataTableColumnOptions
      },
      {
        name: 'firstSeries',
        label: this.translatorService.Tranlate('INVOICE_RANGE_FIRST_SERIES', 'Serie 1'),
        options: {
          filter: false,
          customBodyRender: (value: string, tableMeta: MUIDataTableMeta) => {
            return value;
          }
        }
      },
      {
        name: 'startingNumber',
        label: this.translatorService.Tranlate('INVOICE_RANGE_STARTING_NUMBER', 'Numar inceput'),
        options: {
          filter: false,
          customBodyRender: (value: number, tableMeta: MUIDataTableMeta) => {
            return value;
          }
        }
      },
      {
        name: 'currentNumber',
        label: this.translatorService.Tranlate('INVOICE_RANGE_CURRENT_NUMBER', 'Numar curent'),
        options: {
          filter: false,
          customBodyRender: (value: number | null, tableMeta: MUIDataTableMeta) => {
            return R.isNil(value) ? '' : value;
          }
        }
      },
      {
        name: 'endingNumber',
        label: this.translatorService.Tranlate('INVOICE_RANGE_ENDING_NUMBER', 'Numar sfarsit'),
        options: {
          filter: false,
          customBodyRender: (value: number, tableMeta: MUIDataTableMeta) => {
            return value;
          }
        }
      },
      {
        name: 'lastSeries',
        label: this.translatorService.Tranlate('INVOICE_RANGE_LAST_SERIES', 'Serie 2'),
        options: {
          filter: false,
          customBodyRender: (value: string, tableMeta: MUIDataTableMeta) => {
            return value;
          }
        }
      },
      {
        name: 'invoiceRangeStatus',
        label: this.translatorService.Tranlate(
          'INVOICE_RANGE_STATUS',
          'Status'
        ),
        options: {
          sort: true,
          customSort: (a: IReferential, b: IReferential) => {
            return a.name!.localeCompare(b.name!);
          },
          customBodyRender: (value: IReferential) => {
            return value.name;
          }
        } as MUIDataTableColumnOptions
      },
      {
        name: '',
        options: {
          viewColumns: false,
          filter: false,
          setCellHeaderProps: () => ({ align: 'center' }),
          setCellProps: () => ({ align: 'center' }),
          customBodyRender: (value: boolean, tableMeta: MUIDataTableMeta) => {
            const invoiceRange = this.state.invoiceRanges.find((item) => item.id === tableMeta.rowData[0]);

            return (
              <>
                <IconButton
                  aria-label="edit"
                  color="primary"
                  className="text-primary"
                  size="small"
                  onClick={(e) => this.newInvoiceRatePopup(tableMeta.rowData[0])}
                >
                  <EditOutlinedIcon />
                </IconButton>
                <IconButton
                  aria-label="delete"
                  color="inherit"
                  className="text-danger"
                  size="small"
                  onClick={(e) => this.deleteInvoiceRate(e, tableMeta)}
                >
                  <DeleteOutlineTwoToneIcon />
                </IconButton>
              </>
            );
          }
        }
      }];

    return columns;
  };

  deleteInvoiceRate = async (event: any, tableMeta: MUIDataTableMeta) => {
    try {
      const id = tableMeta.rowData[0];

      await this.vehicleService.RemoveInvoiceRange(id);

      await this.loadInvoiceRanges();

      this.props.enqueueSnackbar(this.translatorService.Tranlate('SUCCES_MSG', 'OK'), {
        variant: 'success'
      });
    } catch (error) {
      this.props.enqueueSnackbar(this.translatorService.Tranlate('ERROR_MSG', 'Eroare'), {
        variant: 'error'
      });
    }
  };


  newInvoiceRatePopup = async (invoiceRateId: number | null) => {
    let newInvoiceRange: InvoiceRange;
    if (invoiceRateId == null) {
      newInvoiceRange = { ...this.state.newInvoiceRange } as InvoiceRange;
    } else {
      newInvoiceRange = this.state.invoiceRanges.find((item) => item.id === invoiceRateId)!;
    }
    this.setState({
      isDialogOpen: true,
      newInvoiceRange: newInvoiceRange,
      newInvoiceRangeId: invoiceRateId
    });
  };

  closeDialog = async () => {
    this.setState(
      { 
        isDialogOpen: false, 
        newInvoiceRange: this.newInvoiceRange ,
        newInvoiceRangeId: null
      }
    );
  };

  public render() {
    this.translatorService = (this.context as AppContext).translatorService;
    this.vehicleService = (this.context as AppContext).vehicleService;
    this.appReferentialService = (this.context as AppContext).referentialService;

    const options = {
      filter: true,
      selectableRows: 'none' as SelectableRows,
      selectableRowsOnClick: false,
      print: false,
      download: false,
      textLabels: MUITranslations.GetTranslations(this.translatorService),
      sort: false,
      customToolbar: () => {
        return (
          <Tooltip title={this.translatorService.Tranlate('Add', 'Adauga')}>
            <IconButton
              aria-label="add"
              color="secondary"
              className="m-2"
              onClick={(e) => this.newInvoiceRatePopup(null)}
            >
              <AddCircleTwoToneIcon />
            </IconButton>
          </Tooltip>
        );
      }
    };

    return (
      <Fragment>
    
       <Box mt={1} pt={1}>
          <div className="d-flex flex-row text-center flex-wrap justify-content-center">
            <ScaleLoader color={'var(--primary)'} loading={this.state.isLoading} />
          </div>
          {!this.state.isLoading ? (
            <MUIDataTable
              title={''}
              data={this.state.invoiceRanges}
              columns={this.getColumns()}
              options={options}
            />
          ) : null}
        </Box>
        {this.state.isDialogOpen ? (
          <Dialog
            onClose={this.closeDialog}
            aria-labelledby="customized-dialog-title"
            open={this.state.isDialogOpen}
            fullScreen={false}
            fullWidth={true}
          >
            <DialogTitle id="customized-dialog-title">
              <Grid container>
                <Grid item xs={11}>
                  <Typography className="MuiTypography-h4">
                  {!this.state.newInvoiceRangeId ? 
                  this.translatorService.Tranlate(
                      'INVOICE_RANGE_NEW_MODAL_TITLE',
                      'Adauga plaja avize/facturi'
                    ) : this.translatorService.Tranlate(
                      'INVOICE_RANGE_UPDATE_MODAL_TITLE',
                      'Actualizeaza plaja avize/facturi'
                    )}       
                  </Typography>
                </Grid>
                <Grid item xs={1}>
                  <IconButton aria-label="close" onClick={this.closeDialog} size={'small'}>
                    <CloseIcon />
                  </IconButton>
                </Grid>
              </Grid>
            </DialogTitle>
            <DialogContent dividers>
              {this.renderAddForm()}
            </DialogContent>
          </Dialog>
        ) : (
          ''
        )}
      </Fragment>
    );
  }
}

export default connect(
  (state: ApplicationState) => ({
    appState: state.app
  }),
  null
)(withSnackbar(InvoiceRangeList as any));
